import React from 'react';
import PropTypes from 'prop-types';

import { GoogleMap } from '../../helpers/GoogleMap';
import { withMediaQuery } from '../../hocs/media-query';

const IPropTypes = {
  center: PropTypes.shape({
    name: PropTypes.string,
    age: PropTypes.number,
  }),
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onExpiry: PropTypes.func,
  isSmallScreen: PropTypes.bool,
  modeEdit: PropTypes.bool,
};

const defaultProps = {
  modeEdit: false,
  center: { lat: -34.90445321195558, lng: -56.186697575382 },
  isSmallScreen: false,
  onSuccess: () => {},
  onError: () => {},
  onExpiry: () => {},
};

const BASE_MAP_ID = 'mapId';

class GoogleMapComponent extends React.Component {
  constructor(props) {
    super(props);
    const randomId = Math.random().toString().replace('.', '');
    this.id = `${BASE_MAP_ID}-${randomId}`;
  }

  componentDidMount() {
    GoogleMap.onReady(() => {
      GoogleMap.render(this.id, this.props.center, this.props.modeEdit);
    });
    this._setCallbacks();
  }

  componentDidUpdate(prevProps) {
    GoogleMap.offSuccess(prevProps.onSuccess);
    GoogleMap.offError(prevProps.onError);
    GoogleMap.offExpiry(prevProps.onExpiry);
    this._setCallbacks();
  }

  componentWillUnmount() {
    GoogleMap.offSuccess(this.props.onSuccess);
    GoogleMap.offError(this.props.onError);
    GoogleMap.offExpiry(this.props.onExpiry);
  }

  _setCallbacks() {
    GoogleMap.onSuccess(this.props.onSuccess);
    GoogleMap.onError(this.props.onError);
    GoogleMap.onExpiry(this.props.onExpiry);
  }

  render() {
    return (
      <div>
        {!this.props.isSmallScreen && !this.props.modeEdit &&
          <div id={this.id} style={{ height: '500px', marginTop: '10px' }} />
        }
        {!this.props.isSmallScreen && this.props.modeEdit &&
          <div id={this.id} style={{ height: '500px', marginTop: '10px' }} />
        }
        {this.props.isSmallScreen &&
          <div id={this.id} style={{ height: '500px', marginTop: '10px' }} />
        }
      </div>
    );
  }
}

GoogleMapComponent.propTypes = IPropTypes;
GoogleMapComponent.defaultProps = defaultProps;

export default withMediaQuery(GoogleMapComponent);



// WEBPACK FOOTER //
// ./src/common/google-map-component/GoogleMapComponent.jsx